import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa'; // Import social media icons
import './AboutUs.css';
import Counter from '../components/Counter';


const AboutUs = () => {
  return (
    <div className="company-profile">
      <div className="about-hero">
        <div className="hero-overlay">
          <h1 className="hero-heading">Adcore Consulting</h1>
          <p className="hero-subheading">Your trusted partner for Printing innovation and top-quality printing services.</p>
          
        </div>
      </div>

      <div className="company-details">
        <div className="company-services">
          <h2>About Us</h2>
          <p>
            Adcore Consultant is at the forefront of Printing and branding solutions. We provide high-quality, innovative Printing solutions, as well as custom printing services to help businesses build strong brands.
          </p>
          <h2>Our Mission</h2>
          <p>
            To empower businesses through creative Designs and Printing services, helping them stand out in their industry with innovative Printingproducts and exceptional customer service.
          </p>
        </div>

        <div className="company-services">
          <h2>What We Offer</h2>
          <ul>
            
            <li>Printing Consultancy</li>
            <li>Custom Printing (Books, T-shirts, Mugs, Bags, etc.)</li>
            <li>Branding & Corporate Identity</li>
            <li>Business Stationery & Marketing Collateral</li>
          </ul>
        </div>

        <div className="company-values">
          <h2>Our Values</h2>
          <ul>
            <li>Innovation: Constantly evolving and embracing new Printing ideas.</li>
            <li>Customer First: Committed to delivering quality service to meet client needs.</li>
            <li>Integrity: Transparency and trust are at the heart of everything we do.</li>
            <li>Excellence: Striving for perfection in every project.</li>
          </ul>
        </div>

        <div className="company-contact">
          <h2>Contact Information</h2>
          <p>Email: info@adcoreconsultant.com</p>
          <p>Phone: +234 802 387 9929</p>
          <p>Address: 123 Main Street, Lagos, Nigeria</p>
          <Link className="quick-order" to={"https://wa.me/2348023879629"}>Quick Order via WhatsApp</Link>

          <div className="social-media">
            <h2>Follow Us</h2>
            <div className="social-icons">
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="https://www.instagram" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
              
            </div>
          </div>
        </div>
      </div>

      <div className="team">
        <div className="ceo" data-aos="fade-up">
          <img src="https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=300" alt="" />
          <h4 className="name">
            Mr. Sunkanmi
          </h4>
          <p className="write">
          Sunkanmi, CEO and founder of Adcore Consulting, has led the company in delivering transformative printing solutions for over a decade. <br /> With expertise in strategic leadership and a passion for excellence, he has built Adcore into a trusted partner for businesses. His vision and dedication to collaboration and integrity have positioned Adcore Consulting as a leader in the printing industry.
          </p>
        </div>
      </div>

      <div className="company-products">
        <h2>Our Products</h2>
        <ul>
          <li><Link to="/category/Books">Books</Link></li>
          <li><Link to="/category/Tshirt_Branding">T-shirt Branding</Link></li>
          <li><Link to="/category/Custom_Mugs">Custom Mugs</Link></li>
          <li><Link to="/category/Bags">Bags</Link></li>
          <li><Link to="/category/Business_Cards">Business Cards</Link></li>
        </ul>
      </div>
      <Counter/>
    </div>
  );
};

export default AboutUs;
